import { Box, Typography } from "@mui/material";
import {
  WarningAmberRounded as AlertIcon,
  Check as CheckIcon,
} from "@mui/icons-material";
import PropTypes from "prop-types";

const ACCENT = "#4A78BC";

/**
 * "Angaben bestätigen" — the final customer confirmation. A red warning box on
 * top and a compact checkbox card (toggling `alles_korrekt`), matching the
 * Schmidt click dummy. The step's `requireCheck: "alles_korrekt"` gates "Weiter".
 */
export default function ClaimConfirm({ values = {}, onChange, disabled = false }) {
  const checked = Boolean(values.alles_korrekt);
  const toggle = () => {
    if (disabled) return;
    onChange?.({ target: { name: "alles_korrekt", value: !checked } });
  };

  return (
    <Box sx={{ width: "100%", display: "flex", flexDirection: "column", gap: "16px" }}>
      {/* Warning box */}
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "10px",
          backgroundColor: "#FCE9E4",
          border: "1px solid #f3c6ba",
          borderRadius: "10px",
          p: "12px 14px",
        }}
      >
        <AlertIcon sx={{ fontSize: 19, color: "#E63F25", flex: "none", mt: "1px" }} />
        <Typography sx={{ fontSize: "12.5px", color: "#7a2417", lineHeight: 1.5 }}>
          Bewusst unwahre oder lückenhafte Angaben können zum Verlust des
          Versicherungsschutzes führen – auch wenn dem Versicherer dadurch kein
          Nachteil entsteht.
        </Typography>
      </Box>

      {/* Confirmation checkbox card */}
      <Box
        component="button"
        type="button"
        disabled={disabled}
        onClick={toggle}
        sx={{
          width: "100%",
          textAlign: "left",
          cursor: disabled ? "default" : "pointer",
          fontFamily: "inherit",
          display: "flex",
          alignItems: "flex-start",
          gap: "11px",
          backgroundColor: "#f8fafc",
          border: `1.5px solid ${checked ? ACCENT : "#dde3ec"}`,
          borderRadius: "10px",
          p: "13px 15px",
        }}
      >
        <Box
          sx={{
            width: 20,
            height: 20,
            borderRadius: "5px",
            flex: "none",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: checked ? ACCENT : "#fff",
            border: checked ? "none" : "1.5px solid #cbd5e1",
          }}
        >
          {checked && <CheckIcon sx={{ fontSize: 13, color: "#fff" }} />}
        </Box>
        <Typography sx={{ fontSize: "13px", color: "#374151", lineHeight: 1.5 }}>
          Ich habe die Fragen wahrheitsgemäß beantwortet und bin mit der Auszahlung
          einer evtl. Entschädigung an den Anspruchsteller einverstanden.
        </Typography>
      </Box>
    </Box>
  );
}

ClaimConfirm.propTypes = {
  values: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};
